import {
  USER_LOGIN,
  USER_CREATE,
  USER_LOGOUT,
  USER_RESET,
  USER_UPDATE,
} from '../actions/types'

const defaultUser = {
  first_name: '',
  last_name: '',
  email: '',
  phone_number: '',
  isLoggedIn: false,
  role: '',
  auth_token: '',
  maintained_profiles: [],
  requested_profiles: [],
  reduxLogInComplete: false,
  isOnboarding: false
}

export default function user (state = defaultUser, action){
  const { user } = action
  let newState

  switch (action.type) {
    case USER_LOGIN:
      newState = {
        ...state,
        ...user,
      }
      return newState
    case USER_CREATE:
      newState = {
        ...defaultUser,
        ...user,
      }
      return newState
    case USER_UPDATE:
      newState = {
        ...state,
        ...user,
      }
      return newState
    case USER_LOGOUT:
    case USER_RESET:
      return defaultUser
    default:
      return state
  }
}


// WEBPACK FOOTER //
// ./src/reducers/user.js